module.exports = __webpack_public_path__ + "2345ded090967b507e7e68fad9872de3.jpg";